export default function sortNumbers(first, second) {
    return first - second;
}
//# sourceMappingURL=sort-numbers.js.map